import React from 'react';
import type { PlanTermProps } from '../context';
import T from 'i18n-react';
import Typography from '@material-ui/core/Typography';

export type AcceptingNumberProps = Pick<
  PlanTermProps,
  'number' | 'isAccepting' | 'isFutureOpen',
>;

export const getCapacityText = (number) =>
  T.translate('plan.capacity', { num: number?.toLocaleString?.() });

const AcceptingNumber = ({
  number,
  isAccepting,
  isFutureOpen,
}: AcceptingNumberProps) => {
  let text;
  if (isAccepting) {
    text = getCapacityText(number);
  } else if (isFutureOpen) {
    text = 'Coming Soon';
  } else {
    text = T.translate('plan.finished');
  }

  return (
    <Typography
      component="span"
      variant="inherit"
      color={isAccepting || isFutureOpen ? 'textPrimary' : 'textSecondary'}
    >
      {text}
    </Typography>
  );
};

export default AcceptingNumber;
